import { z } from 'zod';
import { NullableJsonValue } from "../inputTypeSchemas/NullableJsonValue"
import { CoreCustomFieldTypeSchema } from '../inputTypeSchemas/CoreCustomFieldTypeSchema'
import { NumberFilterConditionsSchema } from '../inputTypeSchemas/NumberFilterConditionsSchema'
import { StringFilterConditionsSchema } from '../inputTypeSchemas/StringFilterConditionsSchema'
import { BooleanFilterConditionsSchema } from '../inputTypeSchemas/BooleanFilterConditionsSchema'
import { DateFilterConditionsSchema } from '../inputTypeSchemas/DateFilterConditionsSchema'
import { DropdownConditionsSchema } from '../inputTypeSchemas/DropdownConditionsSchema'

/////////////////////////////////////////
// CORE DATA FILTER SCHEMA
/////////////////////////////////////////

export const CoreDataFilterSchema = z.object({
  type: CoreCustomFieldTypeSchema,
  numberCondition: NumberFilterConditionsSchema.nullable(),
  stringCondition: StringFilterConditionsSchema.nullable(),
  booleanCondition: BooleanFilterConditionsSchema.nullable(),
  dateCondition: DateFilterConditionsSchema.nullable(),
  dropdownCondition: DropdownConditionsSchema.nullable(),
  id: z.number().int(),
  filterGroupId: z.number().int(),
  order: z.number().int(),
  field: z.string(),
  fieldId: z.bigint().nullable(),
  fieldTable: z.string().nullable(),
  integerValue: z.number().int().nullable(),
  floatValue: z.number().nullable(),
  stringValue: z.string().nullable(),
  booleanValue: z.boolean().nullable(),
  startDateValue: z.coerce.date().nullable(),
  endDateValue: z.coerce.date().nullable(),
  jsonValue: NullableJsonValue.optional(),
})

export type CoreDataFilter = z.infer<typeof CoreDataFilterSchema>

export default CoreDataFilterSchema;
